export default __webpack_public_path__ + "locales/cs/Article.json?hash=75b3c8a07f9af5cfb3d6600addcbb878";